import { createContext } from 'react';
import type { QuestionOption } from '@aphp-ema/common/questionnaire';

export type QuestionOperationsContextType = {
  onTypeChange?: (questionId: string, onChange: () => void) => void;
  onOptionsChange?: (
    questionId: string,
    oldOptions: QuestionOption[] | null,
    newOptions: QuestionOption[] | null,
    onChange: () => void,
  ) => void;
  onAllowMultipleChange?: (
    questionId: string,
    newAllowMultiple: boolean,
    onChange: () => void,
  ) => void;
  onRemove?: (index: number) => void;
};

export const QuestionOperationsContext = createContext<
  QuestionOperationsContextType | undefined
>(undefined);
